import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, Icon } from "semantic-ui-react";

import { useBooleanState } from "hooks";
import DatePickerInput from "components/DatePickerInput";
import MeetingDateTypeDropdown from "components/MeetingDateTypeDropdown";

const EditingInlineEvent = ({
  setEditing,
  currentDate,
  setCurrentDate,
  loading,
  editEvent,
  eventMeetingDateType,
}) => {
  const [selectedMeetingDateType, setSelectedMeetingDateType] =
    useState(eventMeetingDateType);
  const [inputDateError, setError, clearError] = useBooleanState();

  return (
    <div
      style={{
        marginBottom: "1em",
        width: "max-content",
      }}
      data-test="editing-event-form"
    >
      <MeetingDateTypeDropdown
        selectedMeetingDateType={selectedMeetingDateType}
        setSelectedMeetingDateType={setSelectedMeetingDateType}
        useDefaultValue={false}
      />
      <DatePickerInput
        defaultDate={currentDate}
        onChange={(d) => {
          if (d) {
            setCurrentDate(d);
            clearError();
          } else {
            setError();
          }
        }}
      />
      <div>
        <Button
          content="Save"
          disabled={loading || inputDateError}
          loading={loading}
          onClick={() => {
            editEvent(selectedMeetingDateType?.id);
          }}
          positive
        />
        <Icon
          color="grey"
          link
          name="delete"
          onClick={() => {
            setEditing(false);
          }}
          size="large"
        />
      </div>
    </div>
  );
};

EditingInlineEvent.propTypes = {
  setEditing: PropTypes.func.isRequired,
  currentDate: PropTypes.object.isRequired,
  setCurrentDate: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  editEvent: PropTypes.func.isRequired,
  eventMeetingDateType: PropTypes.object.isRequired,
};

export default EditingInlineEvent;
